import {atom } from 'recoil';

export const  PublicationFilter = atom({
  key: "PublicationFilter",
  default: 
    "all"

})